import { ArrowRight, FolderOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

import { useOrganizationPockets } from "../hooks/useOrganizationPockets";
import { usePocketsVisibility } from "../hooks/usePocketsVisibility";

export const ActivatePocketsBanner = () => {
  const { t } = useTranslations("cards");
  const navigate = useNavigate();

  const { visible, isLoading: visibilityLoading } = usePocketsVisibility();
  const { pockets, isLoading, error } = useOrganizationPockets();

  // The feature is gated: organizations without a funded pocket never see the
  // activation nudge. (When `visible` is true the org already has pockets, so
  // the checks below short-circuit anyway.)
  if (visibilityLoading || !visible) return null;
  if (isLoading) return null;
  if (!error && pockets.length > 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-dashed border-gray-300 bg-gray-50 p-4 dark:border-zinc-700 dark:bg-zinc-900/40">
      <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white text-gray-500 ring-1 ring-gray-200 dark:bg-zinc-800 dark:text-zinc-300 dark:ring-zinc-700">
        <FolderOpen className="h-5 w-5" />
      </span>

      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-900 dark:text-white">{t("pockets_activate_title")}</p>
        <p className="text-xs text-gray-500 dark:text-zinc-400">{t("pockets_activate_subtitle")}</p>
      </div>

      <ColocaButton
        size="sm"
        variant="default"
        iconTrailing={ArrowRight}
        onClick={() => navigate("/app/cards/pockets")}
      >
        {t("pockets_activate_button")}
      </ColocaButton>
    </div>
  );
};
